// extracted by mini-css-extract-plugin
export var hideEditor = "_lz-2";
export var infoIcon = "_lz-3";
export var label = "_lz-1";
export var labelContainer = "_lz-0";
export var readonlyText = "_lz-4";